import "./styles.css";

const MainLogo = () => {
  return (
    <svg
      width="205.886"
      height="26"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 923.24 126.85"
      className="site-logo"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M102.57 41.29V11.73C95.3 6.11 83.24 0 64.91 0 28.08 0 0 28.24 0 63.42c0 35.51 28.41 63.42 64.91 63.42 18.33 0 30.39-6.28 37.66-11.89V85.39c-8.81 7.09-21.14 13.71-33.7 13.71-21.14 0-37.49-14.2-37.49-35.68 0-21 15.36-35.68 37.49-35.68 12.88 0 24.36 6.44 33.69 13.54M126.18 2.15h29.73V125.2h-29.73zM273.9 29.89V2.15h-98.11v27.74h34.19v95.3h29.56v-95.3h34.36zM403.88 2.15h-33.36l-27.91 45.58-27.92-45.58H281.5l46.41 75.97v47.07h29.56V78.12l46.41-75.97zM679.68 74.49h-21.31l10.57-34.35Zm10.08 27.58L698 125.2h30.56l-44.43-123h-30.22l-44.43 123H640l8.26-23.12ZM824.8 97.45h-44.54V2.15h-31.93v123.04h76.47V97.45zM923.24 97.45H878.7V2.15h-31.93v123.04h76.47V97.45zM593.36 2.15h-28.58l-28.13 49.38-28.52-49.38h-28.19v123.04h28.96V54.34l2.25 3.51 20.05 35.08h10.74l20.78-35.71 1.68-2.88v70.85h28.96V2.15z"></path>
        </g>
      </g>
    </svg>
  );
};

export default MainLogo;
